module.exports = __webpack_public_path__ + "static/media/19.624ff983.jpg";